module.exports = "<section> <div ng-show=!isEmptyRange class=\"cd-timeline-label label-ll\" style=\"\"> {{ageRangeText}} </div> </section> ";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/ageRange/ageRange.html
// module id = 1139
// module chunks = 0